<template>
  <div class="space-y-4">
    <div v-show="view === 'review'" class="space-y-4">
      <Label class="text-sm text-muted-foreground">Notify candidate via:</Label>

      <div class="space-y-3">
        <div class="rounded-lg border p-4 space-y-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <vue-feather type="mail" class="h-4 w-4 text-muted-foreground" />
              <Label for="send-email" class="font-medium cursor-pointer">Email</Label>
              <PersonalEmailUnverified v-if="!postmarkVerified" />
            </div>
            <Switch
              :model-value="shouldSendEmail"
              :disabled="!postmarkVerified"
              @update:model-value="shouldSendEmail = $event"
            />
          </div>
          <Alert v-if="!postmarkVerified" variant="info" class="flex gap-2 items-center">
            <vue-feather type="info" class="h-4 w-4" />
            <AlertDescription> Verify your personal email to send emails to candidates. </AlertDescription>
          </Alert>
          <template v-if="postmarkVerified && shouldSendEmail">
            <p class="text-sm text-muted-foreground line-clamp-2">
              {{ emailSubject }}
            </p>
            <Button variant="minimal" @click="view = 'edit_email'"> Edit </Button>
          </template>
        </div>

        <div class="rounded-lg border p-4 space-y-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <vue-feather type="message-circle" class="h-4 w-4 text-muted-foreground" />
              <Label for="send-sms" class="font-medium cursor-pointer">SMS</Label>
            </div>
            <Switch
              :model-value="shouldSendSms"
              :disabled="!canReceiveSms"
              @update:model-value="shouldSendSms = $event"
            />
          </div>
          <Alert v-if="!canReceiveSms" variant="info" class="flex gap-2 items-center">
            <vue-feather type="info" class="h-4 w-4" />
            <AlertDescription> This candidate did not opt-in to SMS messaging. </AlertDescription>
          </Alert>
          <p v-if="shouldSendSms" class="text-sm text-muted-foreground line-clamp-2">
            {{ smsMessage }}
          </p>
          <Button v-if="shouldSendSms" variant="minimal" @click="view = 'edit_sms'"> Edit </Button>
        </div>
      </div>
    </div>

    <EmailInput v-if="view === 'edit_email'" v-model:subject="emailSubject" v-model:body="emailBody" />
    <ChatInput v-if="view === 'edit_sms'" v-model="smsMessage" />
  </div>
</template>

<script setup lang="ts">
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import EmailInput from '@/components/shared/EmailInput.vue';
import ChatInput from '@/components/shared/ChatInput.vue';
import PersonalEmailUnverified from '@/components/shared/EmailBadge/PersonalEmailUnverified.vue';
import type { UseCandidateScheduleInputReturn } from './useCandidateScheduleInput';
import Switch from '@/components/ui/switch/Switch.vue';

type Props = {
  input: UseCandidateScheduleInputReturn;
};

defineEmits<{ back: [] }>();

const props = defineProps<Props>();
const { view, postmarkVerified, canReceiveSms, shouldSendEmail, shouldSendSms, emailSubject, emailBody, smsMessage } =
  props.input;
</script>
